(function () {
  if (window.__ekarisProductCardBound) return;
  window.__ekarisProductCardBound = true;

  const cardOf = (el) => el.closest('.ekc');

  const syncQuantity = (card) => {
    const qtyInput = card.querySelector('[data-ekc-qty]');
    const fastrrQty = card.querySelector('[data-ekc-fastrr-qty]');
    const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    if (fastrrQty) fastrrQty.value = String(quantity);
    return quantity;
  };

  const applyVariant = (card, option) => {
    if (!card || !option) return;

    const variantId = option.value;
    const available = option.dataset.available !== 'false';
    const idInput = card.querySelector('input[name="id"]:not([data-ekc-fastrr-id])');
    const fastrrId = card.querySelector('[data-ekc-fastrr-id]');
    const priceEl = card.querySelector('[data-ekc-price]');
    const compareEl = card.querySelector('[data-ekc-compare]');
    const couponEl = card.querySelector('[data-ekc-coupon]');
    const couponAmount = card.querySelector('[data-ekc-coupon-amount]');
    const imageEl = card.querySelector('[data-ekc-image]');
    const atc = card.querySelector('[data-ekc-atc]');
    const atcPrice = card.querySelector('[data-ekc-atc-price]');
    const buyWrap = card.querySelector('.ekc__buy-wrap');

    if (idInput) idInput.value = variantId;
    if (fastrrId) {
      fastrrId.value = variantId;
      fastrrId.disabled = !available;
    }
    if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

    if (compareEl) {
      const hasCompare = option.dataset.hasCompare === 'true' && option.dataset.compare;
      compareEl.textContent = hasCompare ? option.dataset.compare : '';
      compareEl.hidden = !hasCompare;
    }

    const discountEl = card.querySelector('[data-ekc-discount]');
    if (discountEl) {
      const percent = parseInt(option.dataset.discountPercent, 10) || 0;
      const hasDiscount = option.dataset.hasCompare === 'true' && percent > 0;
      discountEl.textContent = hasDiscount ? percent + '% OFF' : '';
      discountEl.hidden = !hasDiscount;
    }

    if (couponEl) {
      const showCoupon = Boolean(option.dataset.bestPrice) && (option.dataset.hasCompare === 'true' || option.dataset.showCoupon === 'true');
      if (couponAmount && option.dataset.bestPrice) couponAmount.textContent = option.dataset.bestPrice;
      couponEl.hidden = !showCoupon;
    }

    if (imageEl && option.dataset.image) {
      imageEl.src = option.dataset.image;
      if (option.dataset.srcset) imageEl.srcset = option.dataset.srcset;
    }

    if (atc) {
      atc.disabled = !available;
      const label = atc.querySelector('[data-ekc-atc-label]');
      if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
      const atcDivider = atc.querySelector('.ekc__atc-divider');
      if (atcPrice) {
        if (available && option.dataset.price) {
          atcPrice.textContent = option.dataset.price;
          atcPrice.hidden = false;
          if (atcDivider) atcDivider.hidden = false;
        } else {
          atcPrice.hidden = true;
          if (atcDivider) atcDivider.hidden = true;
        }
      }
    }
    if (buyWrap) buyWrap.hidden = !available;

    card.querySelectorAll('[data-ekc-variant-pill]').forEach((pill) => {
      const active = pill.dataset.variantId === variantId;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-checked', active ? 'true' : 'false');
    });
  };

  const getCartUi = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const openShiprocketCart = () => {
    if (typeof window.slideShiprocketSmartCartInFrame === 'function') {
      window.slideShiprocketSmartCartInFrame(true);
      return true;
    }

    const api = window.srSmartCart || window.ShiprocketSmartCart || window.SR_SMART_CART || window.shiprocketSmartCart;
    if (api && typeof api.openCart === 'function') {
      api.openCart();
      return true;
    }
    if (api && typeof api.open === 'function') {
      api.open();
      return true;
    }

    document.dispatchEvent(new CustomEvent('shiprocket:openSmartCart'));

    const trigger = document.querySelector(
      '[data-sr-smart-cart-trigger], .sr-smart-cart-button, #sr-smart-cart-button, .sr-smart-cart-trigger, [data-shiprocket-smart-cart], #cart-icon-bubble'
    );
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  };

  const openCartDrawer = (cart, data) => {
    try {
      if (cart && typeof cart.renderContents === 'function' && data && data.sections) {
        cart.renderContents(data);
      } else if (cart) {
        cart.classList.remove('is-empty');
        cart.querySelector('.drawer__inner-empty')?.remove();
        cart.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      }
    } catch (error) {
      /* fall through */
    }

    if (cart && typeof cart.open === 'function') {
      cart.open();
    }

    if (!openShiprocketCart()) {
      window.setTimeout(openShiprocketCart, 400);
    }
  };

  const addToCart = async (card) => {
    const idInput = card.querySelector('input[name="id"]:not([data-ekc-fastrr-id])') || card.querySelector('[data-ekc-fastrr-id]');
    const variantId = idInput && idInput.value;
    if (!variantId) return;

    const cart = getCartUi();
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', String(syncQuantity(card)));
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body,
    });
    const data = await response.json();

    if (data.status) {
      throw new Error(data.description || data.message || 'Unable to add to cart');
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'ekaris-product-card',
        productVariantId: variantId,
        cartData: data,
      });
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
    openCartDrawer(cart, data);
    return data;
  };

  const setBusy = (button, busy, busyLabel) => {
    if (!button) return;
    if (busy) {
      button.dataset.ekcOriginal = button.innerHTML;
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
      const label = button.querySelector('[data-ekc-atc-label]');
      if (label && busyLabel) label.textContent = busyLabel;
    } else {
      button.removeAttribute('aria-disabled');
      if (button.dataset.ekcOriginal) button.innerHTML = button.dataset.ekcOriginal;
      button.disabled = false;
    }
  };

  const showError = (card, message) => {
    let error = card.querySelector('[data-ekc-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'ekc__error';
      error.setAttribute('data-ekc-error', '');
      card.querySelector('.ekc__actions')?.appendChild(error);
    }
    error.textContent = message || '';
    error.hidden = !message;
  };

  document.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-ekc-variant-pill]');
    if (!pill || pill.disabled) return;
    const card = cardOf(pill);
    const select = card?.querySelector('[data-ekc-select]');
    if (!select) return;
    const option = [...select.options].find((item) => item.value === pill.dataset.variantId);
    if (!option) return;
    event.preventDefault();
    select.value = option.value;
    applyVariant(card, option);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ekc-select]');
    if (select) {
      applyVariant(cardOf(select), select.options[select.selectedIndex]);
      return;
    }
    if (event.target.closest('[data-ekc-qty]')) {
      const card = cardOf(event.target);
      if (card) syncQuantity(card);
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.closest('[data-ekc-qty]')) return;
    const card = cardOf(event.target);
    if (card) syncQuantity(card);
  });

  document.addEventListener('click', async (event) => {
    const atc = event.target.closest('[data-ekc-atc]');
    if (!atc) return;

    const card = cardOf(atc);
    if (!card) return;
    event.preventDefault();
    if (atc.disabled || atc.getAttribute('aria-disabled') === 'true') return;

    showError(card, '');
    setBusy(atc, true, 'Adding…');

    try {
      await addToCart(card);
      const label = atc.querySelector('[data-ekc-atc-label]');
      if (label) label.textContent = 'Added';
      setTimeout(() => setBusy(atc, false), 1200);
    } catch (error) {
      showError(card, error.message || 'Unable to add to cart');
      setBusy(atc, false);
    }
  });
})();
